module.exports = __webpack_public_path__ + "img/Icon-arrow_back_ios.2f26a1e5.svg";